import { ILease } from '../../../views/lease/i-lease.interface';
import { INotificationEditData } from './i-notificationeditdata.interface';

import { BusinessObject } from '../../../shared/business-object.model';
import { LeaseRate } from '../../../views/lease/lease-rate.model';
import { Customer } from '../../../views/customer/customer.model';
import { Lease } from '../../../views/lease/lease.model';

export class NotificationEditData extends BusinessObject implements INotificationEditData {
	constructor(item?: any ) {
		super(item);
	}

	notificationId: number | null | undefined;
	category: string;
	value: Date;
	data: any[];
	lease: ILease;
}